import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Youtube, Smartphone, Truck, RotateCcw, Wallet } from 'lucide-react';
import { useLocale } from '../context/LocaleContext';
import { absMediaUrl } from './ProductCard';

const LOGO_SRC = '/api/files/feronstore/brand/b917f5ca85b544458ebf6869329c79ff.webp';

const Footer = () => {
  const { t, formatPrice, freeShipThresholdINR } = useLocale();

  const cols = [
    { titleKey: 'needHelp', items: [
      { key: 'contactUs', to: '/contact-us' },
      { key: 'trackOrder', to: '/track-order' },
      { key: 'returnsRefunds', to: '/returns-refunds' },
      { key: 'faqs', to: '/faqs' },
      { key: 'myAccountLink', to: '/my-orders' },
    ]},
    { titleKey: 'company', items: [
      { key: 'aboutUs', to: '/about-us' },
      { key: 'giftVouchers', to: '/gift-vouchers' },
    ]},
  ];

  return (
    <footer className="bg-[#f5f5f5] mt-20 pt-14 pb-6">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 sm:grid-cols-2 gap-10">
        {cols.map((c) => (
          <div key={c.titleKey}>
            <h4 className="font-bold text-sm tracking-wider text-[#22c55e] mb-4">{t(c.titleKey)}</h4>
            <ul className="space-y-2">
              {c.items.map((it) => (
                <li key={it.key}>
                  <Link to={it.to} className="text-[13px] text-gray-700 hover:text-black transition-colors" data-testid={`footer-link-${it.key}`}>{t(it.key)}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-6 mt-12 border-t border-gray-300 pt-8">
        <div className="flex items-center gap-3"><Wallet className="text-[#22c55e]" size={22} /><span className="text-[13px] font-semibold">{t('codAvailable')}</span></div>
        <div className="flex items-center gap-3"><RotateCcw className="text-[#22c55e]" size={22} /><span className="text-[13px] font-semibold">{t('easyReturns')}</span></div>
        <div className="flex items-center gap-3"><Truck className="text-[#22c55e]" size={22} /><span className="text-[13px] font-semibold">{t('freeShippingWorldwide')}</span></div>
        <div className="flex items-center gap-3"><Smartphone className="text-[#22c55e]" size={22} /><span className="text-[13px] font-semibold">{t('experienceApp')}</span></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-10 flex flex-col md:flex-row justify-between items-center border-t border-gray-300 pt-6 gap-4">
        <div className="flex items-center gap-3">
          <img src={absMediaUrl(LOGO_SRC)} alt="Feron" width={96} height={96} className="h-12 w-auto object-contain" loading="lazy" decoding="async" />
          <span className="text-xs text-gray-600">{t('copyright')}</span>
        </div>
        <div className="flex gap-4 text-gray-600">
          <a href="https://www.instagram.com/feron._store" target="_blank" rel="noopener noreferrer" aria-label="instagram" data-testid="footer-instagram-link"><Instagram size={20} className="hover:text-[#22c55e] transition" /></a>
          <a href="#" aria-label="facebook"><Facebook size={20} className="hover:text-[#22c55e] transition" /></a>
          <a href="#" aria-label="twitter"><Twitter size={20} className="hover:text-[#22c55e] transition" /></a>
          <a href="#" aria-label="youtube"><Youtube size={20} className="hover:text-[#22c55e] transition" /></a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
